<template>
  <div>
    <h1>{{ $t("optima.category") }} Optima</h1>
    <optima-menu />
    <v-row>
      <v-col cols="12" md="4">
        <ajax-single-file :model.sync="fileId" :label="$t('optima.importCategoryFromXls')" accept="application/xls" :items.sync="items" />
      </v-col>
      <v-col class="mt-3">
        <v-btn color="primary" @click="load">{{ $t("global.load") }}</v-btn>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="categories"
      :footer-props="{ 'items-per-page-options': [{ text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }] }"
      class="elevation-1"
      hide-default-footer
    >
      <template #item="props">
        <tr>
          <td class="text-left">
            {{ props.item.code }}
          </td>
          <td class="text-left">
            {{ props.item.description }}
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import OptimaMenu from "../../components/Optima/OptimaMenu";
import AjaxSingleFile from "../../components/CustomInputComponents/AjaxSingleFile";
export default {
  name: "OptimaSettingsCategoryView",
  components: { AjaxSingleFile, OptimaMenu },
  data: () => ({
    fileId: null,
    items: [],
    categories: []
  }),
  methods: {
    load() {
      this.axios.post("optima/import-categories", { fileId: this.fileId }).then(() => {
        this.downloadCategories();
        this.$store.dispatch("snackbarPush", {
          text: this.$t("global.saved"),
          position: "down"
        });
      });
    },
    downloadCategories() {
      this.axios.get("optima/get-categories").then(response => {
        this.categories = response.data;
      });
    }
  },
  computed: {
    headers() {
      return [
        { text: this.$t("global.name"), value: "code" },
        {
          text: this.$t("global.description"),
          value: "description"
        }
      ];
    }
  },
  created() {
    this.downloadCategories();
  }
};
</script>

<style scoped></style>
